import { db } from "./Firebase"

const tblCategories = 'categories'

export default {
   getRef() {
      return db().ref(tblCategories)
   },
   getCategoryById(id) {
      return db().ref(tblCategories).child(id).once('value')
   },
   storeCategory(obj) {
      let timestamp   = new Date().getTime()
      let newCategory = db().ref(tblCategories).push()

      let categoryData = {
         id        : newCategory.key,
         name      : obj.name,
         status    : obj.status ? '1': '0',
         created_at: timestamp,
         updated_at: timestamp,
      }
      // let updates = {}
      // updates[`/${tblProducts}/${newCategoryKey}`] = categoryData
      // return db().ref().update(updates)
      return newCategory.set(categoryData)
   },
   updateCategory(obj) {
      let timestamp   = new Date().getTime()

      let categoryData = {
         name      : obj.name,
         status    : obj.status ? '1': '0',
         updated_at: timestamp,
      }

      return db().ref(tblCategories).child(obj.id).update(categoryData)
   },
   deleteCategory(id) {
      return db().ref(tblCategories).child(id).remove()
   }
}
